module.exports = __webpack_public_path__ + "media/xunweiyingwen.203a4948.mp4";